import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

const Separator = styled(Box)({
  borderTop: '1px solid #A7A4E0',
  height: '1px',
  width: '99%',
});

export default Separator;